module.exports = __webpack_public_path__ + "img/c5.0540439d.png";